import { Div, Collection, Span } from "@tblabs/truffle";
import { Human } from "../../../../Models/Human";


export class PeoplePrinter extends Div
{
    constructor(people: Collection<Human>)
    {
        super("");

        this.Append(
            ...people.Map(x =>
                new Div().Text(`${x.Type.value}\n${x.ExperienceIcon} ${x.Name.value}\n☎️ ${x.Phone.value} / ${x.Email.value}\n📌 ${x.Address.value}\n🗒️ ${x.Description.value || "(brak notatki)"}\n${x.Origin.value || "(brak źródła)"}`)
                .Style(`font-size: 1rem; padding: 1rem; margin: 1rem; border-bottom: 1px solid #f3f4f6; background-color: #f9fafb;`)
            )
        );
    }
}
